module.exports = __webpack_public_path__ + "media/images/emoticons/dash-1e2bc2c7cbbe135d2f4a0158ed2a9ebf.gif";